import { render, staticRenderFns } from "./MotifAdmin.vue?vue&type=template&id=61a7ff25&"
import script from "./MotifAdmin.vue?vue&type=script&lang=js&"
export * from "./MotifAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports